<template>
	<div class="tabWrapperSettings tabDepartments">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="itemsDepartments"
				@updateClickButton="onClickButton($event, flag)"
				@updateCreate="onCreate"
				text-create="Add new department"
				page-title="Departments"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-departments
				v-if="isViewDepartments"
				:dialogFlag="dialogFlag"
				:editDepartments="editDepartments"
				@updateSave="onSaveViewDepartments"
				@updateClose="onCloseDialog('isViewDepartments')"
				@updateList="onUpdateList('departments')"
		></view-departments>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabDepartmentsTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewDepartments from "@/components/Settings/UserAccountSettings/ViewDepartments/ViewDepartments.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabDepartments",
	components: {
		DialogRemove,
		ViewDepartments,
		MainTable
	},
	computed: {
		...mapGetters([
			'editDepartments',
			'settingsDepartments',
			'itemsDepartments',
			'filtersDepartments',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabDepartmentsTable;
		},
	},

	data: () => ({
		flag: TAB.DEPARTMENTS,

		isViewDepartments: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountDepartmentsList',
			'getAccountDepartmentsEdit',
			'deleteAccountDepartments',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DEPARTMENTS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'departments') {
				await this.getAccountDepartmentsList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabDepartments' && key === 'edit1') {
				this.accountDepartmentsEdit();
			}
			if (nameComponent === 'tabDepartments' && key === 'delete1') {
				const title = TITLE.REMOVE_DEPARTMENTS;
				const text = TEXT.REMOVE_DEPARTMENTS;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabDepartments') {
				const { id } = this.activeItem;
				await this.deleteAccountDepartments(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountDepartmentsEdit() {
			const { id } = this.activeItem;
			await this.getAccountDepartmentsEdit(id);
			this.isViewDepartments = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewDepartments = true;
		},
		onSaveViewDepartments(args) {
			console.info('%c [ onSaveViewDepartments args  ] ', 'color:#bada55', typeof args, args);
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountDepartmentsList();

	}
};
</script>

<style scoped lang="scss">

.tabDepartments {
	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-bottom: 10px;
	}
}
</style>

